import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { passthroughSearch } from '@/router/search';
import Streams from '@/ui/pages/Streams/Streams';

export const Route = createFileRoute('/_dashboard/streams/')({
  validateSearch: passthroughSearch,
  beforeLoad: requireRoute('/streams'),
  component: Streams,
});
